/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramGeoControllerGetCountriesQueryResponse } from '../../types/TelegramGeoControllerGetCountries.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetCountries } from '../../methods/telegramGeoGetCountries.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetCountriesQueryKey = () => [{ url: '/api/telegram/geo/countries' }] as const;

export type TelegramGeoGetCountriesQueryKey = ReturnType<typeof telegramGeoGetCountriesQueryKey>;

export function telegramGeoGetCountriesQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = telegramGeoGetCountriesQueryKey();
  return queryOptions<
    TelegramGeoControllerGetCountriesQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetCountriesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetCountries(config);
    },
  });
}

/**
 * {@link /api/telegram/geo/countries}
 */
export function useTelegramGeoGetCountries<
  TData = TelegramGeoControllerGetCountriesQueryResponse,
  TQueryData = TelegramGeoControllerGetCountriesQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetCountriesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetCountriesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetCountriesQueryKey();

  const query = useQuery(
    {
      ...telegramGeoGetCountriesQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
